import React from 'react';
import { Box, Typography } from '@mui/material';
import ResponsiveLayout from '../../../../components/common/ResponsiveLayout';

const ErrorState: React.FC<{ error: string }> = ({ error }) => (
  <ResponsiveLayout>
    <Box sx={{ textAlign: 'center', maxWidth: '600px', p: 3 }}>
      <Typography variant="h4" color="error" gutterBottom>
        Unable to Load Preview
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        {error}
      </Typography>
    </Box>
  </ResponsiveLayout>
);

export default React.memo(ErrorState);
